angular.module('bizmetryApp').service('ProfileService', ['$http', 'CONFIG', function ($http, CONFIG) {

  function getAccountId() {
    const user = JSON.parse(sessionStorage.getItem("user"));
    return user?.id;
  }

  // 💥 Esta es la versión correcta:
  this.updateProfileField = function (profileId, fieldsToUpdate) {
    return $http.patch(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profileId}`,
      fieldsToUpdate,
    );
  };

  // 📘 1. Obtener todos los perfiles por cuenta con filtros opcionales
  this.getAllProfiles = function (options) {
    // options puede traer: { sortCriteria, sortDirection, page, size, search }
    const params = {
      account_id: getAccountId()
    };

    if (options) {
      if (options.sortCriteria) params.sortCriteria = options.sortCriteria;
      if (options.sortDirection) params.sortDirection = options.sortDirection;
      if (options.page != null) params.page = options.page;
      if (options.size != null) params.size = options.size;
      if (options.search) params.search = options.search;
    }

    return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry/profile', {
      params: params,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  };

  // 📘 2. Obtener detalles de un perfil
  this.getProfileById = function (profileId) {
    return $http.get(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profileId}`, {});
  };

  // 📘 3. Crear un nuevo perfil (payload estructurado)
  this.createProfile = function createProfile(data) {
    const payload = {
      profileName: data.profileName,
      profileDescription: data.profileDescription,
      profileProject: data.profileProject,
      createFrom: data.createFrom,
      master_template: {
        id: data.master_template.id,
        name: data.master_template.name
      },
      source_profile: {
        id: data.source_profile.id,
        name: data.source_profile.name
      },
      new_profile: {
        language: {
          id: data.new_profile.language.id,
          name: data.new_profile.language.name
        },
        bizDomain: {
          id: data.new_profile.bizDomain.id,
          name: data.new_profile.bizDomain.name
        },
        bizTechStack: {
          id: data.new_profile.bizTechStack.id,
          name: data.new_profile.bizTechStack.name
        }
      }
    };

    return $http.post(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  };

  // 📘 4. Eliminar un perfil
  this.deleteProfile = function (profileId) {
    return $http.delete(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profileId}`, {});
  };

  this.patchAgent = function (agentId, payload) {
    return $http.patch(CONFIG.BIZMETRY_BACKEND_URL + "/v1/api/bizmetry-agents/agents/" + agentId, payload)
  }

  /**
   * ✅ Batch update de environments
   * 
   * Actualiza múltiples environments en una sola operación transaccional.
   * Este método permite crear, actualizar, reordenar y eliminar environments.
   * 
   * Comportamiento:
   * - Environments con id == null o undefined → Se CREAN nuevos (con agent)
   * - Environments con id != null → Se ACTUALIZAN
   * - Environments que existen en DB pero NO están en el array → Se ELIMINAN
   * 
   * @param {string} profileId - UUID del profile
   * @param {Array} environmentUpdates - Array de environments con estructura:
   * [
   *   {
   *     id: "uuid" | null,              // null para crear nuevo
   *     name: "string",
   *     description: "string",
   *     envType: "DEVELOPMENT|STAGING|PRODUCTION",
   *     envTypeId: "string",
   *     isEnabled: boolean,
   *     envSequence: number,            // Orden/secuencia (0-indexed)
   *     templateInstanceId: "uuid" | null,
   *     templateInstanceStatus: "DRAFT|PUBLISHED|..." | null,
   *     templateInstanceVersion: number | null
   *   }
   * ]
   * 
   * @returns {Promise} Promise con el profile actualizado
   * 
   * @example
   * // Crear nuevo environment
   * ProfileService.batchUpdateEnvironments(profileId, [
   *   {
   *     id: null,  // ← nuevo
   *     name: "Production",
   *     description: "Production environment",
   *     envType: "PRODUCTION",
   *     envTypeId: "3",
   *     isEnabled: false,
   *     envSequence: 2,
   *     templateInstanceId: "template-uuid",
   *     templateInstanceStatus: "PUBLISHED",
   *     templateInstanceVersion: 1
   *   }
   * ]);
   * 
   * @example
   * // Actualizar environments existentes y reordenar
   * ProfileService.batchUpdateEnvironments(profileId, [
   *   { id: "env-1-uuid", name: "Dev", envSequence: 0, ... },
   *   { id: "env-2-uuid", name: "Staging", envSequence: 1, ... },
   *   { id: "env-3-uuid", name: "Prod", envSequence: 2, ... }
   * ]);
   * 
   * @example
   * // Eliminar environment (omitirlo del array)
   * // Si un environment existe en DB pero no está en el array, se eliminará
   * ProfileService.batchUpdateEnvironments(profileId, [
   *   { id: "env-1-uuid", ... },  // se mantiene
   *   { id: "env-2-uuid", ... }   // se mantiene
   *   // env-3 no está → se elimina
   * ]);
   */
  this.batchUpdateEnvironments = function (profileId, environmentUpdates) {
    console.log ('in BATCH UPDATE ENV->', environmentUpdates);
    return $http.put(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profileId}/environments/batch`,
      environmentUpdates,
      {
        headers: {
          'Content-Type': 'application/json'
        },
        bmSkipLoader: true  // suppress global spinner — our loading dialog handles progress feedback
      }
    );
  };

  // Read-only backend preflight for all assignments proposed by roll-up/down.
  this.checkEnvironmentAssignments = function (profileId, environmentUpdates) {
    return $http.post(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profileId}/environments/assignment-check`,
      environmentUpdates,
      { bmSkipLoader: true }
    );
  };

  // 🔒 Pre-check (orquestador) antes de asignar un template a un environment: con el agente
  // fuera de línea no se puede aplicar un cambio de estructura sobre resources ya importados.
  // Responde { allowed, reason, agent_status, blocking_resource_types }.
  this.checkTemplateAssignment = function (profileId, environmentId, templateInstanceId) {
    return $http.post(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-orchestrator/templates/assignment-check`,
      {
        profile_id: profileId,
        environment_id: environmentId,
        template_instance_id: templateInstanceId
      },
      { bmSkipLoader: true }
    );
  };

  // 📘 Eliminar un environment individual
  this.deleteEnvironment = function (profileId, envId) {
    return $http.delete(
      CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry/profile/' + profileId + '/environments/' + envId,
    );
  };

  // ============================================
  // TEMPLATE OPERATIONS
  // ============================================

  // 📘 6. Obtener template instances con filtros opcionales
  /**
   * Obtiene todos los template instances de la cuenta
   * @param {Object} options - Filtros opcionales
   * @param {string} options.profileId - UUID del profile para filtrar
   * @param {string} options.status - Status del template (DRAFT, PENDING_REVIEW, REVIEWED, PUBLISHED)
   * @returns {Promise} Promise con la lista de template instances
   */
  this.getTemplateInstances = function (options) {
    const params = {};

    if (options) {
      if (options.profileId) params.profileId = options.profileId;
      if (options.status) params.status = options.status;
      if (options.sortOrder) params.sortOrder = options.sortOrder;
    }

    return $http.get(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/template-instance`,
      {
        params: params,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  };

  // 📘 7. Obtener template instances por profile ID
  /**
   * Obtiene todos los template instances asociados a un profile específico
   * @param {string} profileId - UUID del profile
   * @param {string} status - Opcional: Status del template para filtrar
   * @returns {Promise} Promise con la lista de template instances del profile
   */
  this.getTemplateInstancesByProfile = function (profileId, status, sortOrder) {
    const options = {
      profileId: profileId
    };

    if (status) {
      options.status = status;
    }

    // ✅ sortOrder: 'ASC' | 'DESC'
    if (sortOrder) {
      options.sortOrder = sortOrder;
      // o si tu backend espera otro nombre:
      // options.sort = sortOrder;
      // options.order = sortOrder;
    }

    return this.getTemplateInstances(options);
  };

  this.getAccountId = getAccountId;

    // ============================================
  // TEMPLATE TREE
  // ============================================

  /**
   * ✅ Obtener el árbol de template versions para un profile.
   *
   * Ordenamiento por nivel (siblings) en backend:
   * - ASC  -> updated_ts más viejo -> más nuevo
   * - DESC -> updated_ts más nuevo -> más viejo
   *
   * @param {string} profileId - UUID del profile
   * @param {string} sort - 'ASC' | 'DESC' (opcional, default ASC)
   * @returns {Promise} Promise con TemplateTreeDTO
   */
  // options.withApiCollections: only template versions associated with at least
  // one API collection (the ones a biz event can target); versions without any
  // come back only as structural ancestors, marked filtered_out.
  this.getTemplateTree = function (profileId, sort, options) {
    const params = {};

    // backend espera ?sort=ASC|DESC
    if (sort) params.sort = sort;
    if (options && options.withApiCollections) params.with_api_collections = true;

    return $http.get(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/profile/${profileId}/template-tree`,
      {
        params: params,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  };

}]);